import script from "./ModelpageFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ModelpageFilter.vue?vue&type=script&setup=true&lang=js"

import "./ModelpageFilter.vue?vue&type=style&index=0&id=be568fde&scoped=true&lang=css"

import exportComponent from "/Users/allard/WebstormProjects/vite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be568fde"]])

export default __exports__